﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import dummy from '../../app/plugins';


import tpl_customSubscriptionStripe from './tpl/customSubscriptionStripe.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';

import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import helper_createWebpage from '../../helper/createWebpage';
import config from '../../../common/config';
import Help from '../../helper/help';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import EventUpdate from '../../helper/eventUpdate';
import View_CustomHeader from '../region/customHeader/customHeader';


export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_customSubscriptionStripe({ model: this.model.toJSON() });
    },
    attributes: function () {
        
    },
    initialize: function () {
        var self = this;

        this.app = this.options.app;

        this.setHasChanged(false);
    },
    help: function () {
        Help.help(this, true, 'custom');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        callback();
    },
    cancelHasChanged: function () {
    },
    modelHasChanged: function () {
    },
    regions: {
    },
    onBeforeShow: function () {
        
    },
    ui: {
        'customSubscriptionStripe_a': '#customSubscriptionStripe_a',
        'help': '#help'
    },
    events: {
        'click #help': 'help'
    },
    onRender: function () {
        var href = 'https://billing.stripe.com/p/login/test_28o6rR8vb1237ZK7ss?prefilled_email=' + this.app.entities.models.custom.attributes.Email;
        this.ui.customSubscriptionStripe_a.attr("href", href);
    },
    onAttach() {
        var self = this;
        
        
    },
    onDestroy() {
       
    },
}, Backbone.Radio.Requests);
